import { type MatEventContext } from "../../../utils/tag-manager";
import { type CanvasBleed, HOME_BLEED, KI_BLEED } from "./slot-geometry";

/**
 * Was die 3D-Insel je Mat-Slot unterscheidet. Kern, Chunk, Ladebedingungen
 * und Rueckfaelle sind fuer alle Slots dieselben (`useMat3dIsland`).
 */
export type Mat3dSlot = {
    /** Praefix der Events: `home` sendet `mat_*`, `ki` sendet `ki_mat_*`. */
    context: MatEventContext;
    /**
     * Media Query, ab der die SVG-Figur sichtbar ist (darunter per CSS
     * versteckt). Passt sie nicht, laedt die Insel nichts und meldet nichts — ein verstecktes Element
     * kann fuer den IntersectionObserver trotzdem «im Viewport» sein.
     */
    visibleFrom?: string;
    /** Meldet die Insel selbst `exposure`? Die Startseite meldet sie ueber `useMatExposure`, je Seitenpfad. */
    reportsExposure: boolean;
    /** Das Element, das die Leinwand traegt und an dem sie ausgerichtet wird. */
    canvasHost: (slot: HTMLElement, svg: SVGSVGElement) => HTMLElement | null;
    bleed: CanvasBleed;
};

/**
 * Startseite (Plan `2026-10-02-mat-3d-website`): jeder Besuch bekommt 3D
 * (Entscheid Jan, 10.10.2026). Die Leinwand liegt im Link des Teasers.
 */
export const MAT3D_HOME_SLOT: Mat3dSlot = {
    context: "home",
    reportsExposure: false,
    canvasHost: (_slot, svg) => svg.closest("a"),
    bleed: HOME_BLEED,
};

/** Ab Tailwind `lg`: darunter ist die Figur im KI-Hero `display: none`. */
export const KI_SLOT_VISIBLE_FROM = "(min-width: 1024px)";

/**
 * KI-Technologie-Hero (Plan `2026-10-10-mat-3d-ki-technologie`): nur ab `lg`,
 * darunter ist die Figur versteckt. Die Figur hat hier kein Linkziel; die
 * Leinwand liegt im Slot selbst.
 */
export const MAT3D_KI_SLOT: Mat3dSlot = {
    context: "ki",
    visibleFrom: KI_SLOT_VISIBLE_FROM,
    reportsExposure: true,
    canvasHost: slot => slot,
    bleed: KI_BLEED,
};
